import React from 'react';

export default function DeclarationAccessibilite() {

    return (<div className='container plan-site-container mt-3'>
        <h1>Déclaration d'accessibilité</h1>

        <div>
            <p>
                La MNH s’engage à rendre son site web accessible conformément à l’article 47 de la loi n° 2005-102 du 11 février 2005 pour l'égalité des droits et des chances, la participation et la citoyenneté des personnes handicapées.
            </p>

            <p>
                À cette fin, elle met en œuvre la stratégie et les actions suivantes :
            </p>
            <p>
                • Suite à un audit d’accessibilité de mnh.fr, La MNH va prochainement mettre en ligne une solution de
                synthèse vocable pour permettre aux utilisateurs d’écouter une version audio du contenu (articles
                MNH-MAG) au fur et à mesure qu’ils suivent le texte mis en surbrillance, ce qui améliore l’accessibilité
                du texte et rend le contenu[node:summary] écrit disponible à un plus grand nombre de personnes. <br/>
                • Un deuxième audit est prévu début d’année 2022, pour améliorer le parcours de navigation UI/UX.
            </p>
            <p>
                Cette déclaration d’accessibilité s’applique au site mnh.fr.
            </p>
            <p>
                État de conformité <br/>
                Le site mnh.fr n’est actuellement pas en conformité avec le référentiel général d’amélioration de
                l’accessibilité (RGAA). L’audit de conformité sur la dernière version du référentiel sera prochainement
                planifié. <br/>
                Un audit de conformité sera réalisé prochainement.
            </p>
            <p>
                Retour d’information et contact <br/>
                Si vous n’arrivez pas à accéder à un contenu ou à un service, vous pouvez contacter le responsable du site internet pour être orienté vers une alternative accessible ou obtenir le contenu sous une autre forme.
            </p>
            <p>
                • Envoyer un message : webmnh@mnh.fr <br/>
                • Contacter : Service communication & Marketing - 02 38 90 76 83
            </p>
            <p>
                Voies de recours <br/>
                Cette procédure est à utiliser dans le cas suivant.
            </p>
            <p>
                Vous avez signalé au responsable du site internet un défaut d’accessibilité qui vous empêche d’accéder à un contenu ou à un des services du portail et vous n’avez pas obtenu de réponse satisfaisante.
            </p>
            <p>
                • Écrire un message au Défenseur des droits (https://formulaire.defenseurdesdroits.fr/) <br/>
                • Contacter le délégué du Défenseur des droits dans votre région (https://www.defenseurdesdroits.fr/fr/saisir/delegues)
            </p>
            <p>
                • Envoyer un courrier par la poste (gratuit, ne pas mettre de timbre) à :
                Défenseur des droits <br/>
                Libre réponse 71120 7 <br/>
                5342 Paris Cedex 07 <br/>
            </p>
            <p>





               </p>
        </div>

    </div>)
}